import { createContext, useContext } from 'react';

import type { AiReviewPartSuggestion } from 'bundles/grading/api/types';
import type { AiSuggestionRating } from 'bundles/grading/utils/aiSuggestionsUtils';

export type AiSuggestionsContextType = {
  loading: boolean;
  aiReviewPartSuggestions: AiReviewPartSuggestion[];
  currentAiReviewPartSuggestion: AiReviewPartSuggestion | null;
  currentAiReviewPartSuggestionApplied: boolean;
  trackSuggestionApplied: () => void;
  currentAiReviewPartSuggestionEdited: boolean;
  trackSuggestionEdited: () => void;
  currentAiReviewPartSuggestionRating: AiSuggestionRating;
  trackSuggestionRating: (feedback: AiSuggestionRating) => void;
};

export const AiSuggestionsContext = createContext<AiSuggestionsContextType | undefined>(undefined);

export const useAiSuggestionsContext = () => {
  const context = useContext(AiSuggestionsContext);
  if (context === undefined) {
    throw new Error('`useAiSuggestionsContext` was used outside of `AiSuggestionsContext.Provider`.');
  }
  return context;
};
